<template>
	<lcsj-dialog v-model="showDetailVisible" :title="title" :modal="false" width="90%" @close="closeDialog()" cancel-text="取消">
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog()">取消</el-button>
				<el-button v-if="type == 1 && subscriptionInfo.state == 1 && $checkBtnPermission('/subscription/index', 'submit')" size="small" :loading="loading" type="primary" @click="handleSubmitClick">
					提交
				</el-button>
				<el-button
					v-if="type == 1 && subscriptionInfo.state == 6 && $checkBtnPermission('/subscription/index', 'receive')"
					size="small"
					:loading="loading"
					type="warning"
					icon="el-icon-coordinate"
					@click="handleReceiveClick"
				>
					接收
				</el-button>
				<el-button
					v-if="type == 1 && (subscriptionInfo.state == 1 || subscriptionInfo.state == 2) && $checkBtnPermission('/subscription/index', 'delete')"
					size="small"
					:loading="loading"
					type="danger"
					@click="handleDeleteClick"
				>
					删除
				</el-button>
			</div>
		</template>
 <div class="main_bg">
			<div class="item_info border_Warningcolor">
				<el-descriptions :column="3" :border="true" title="申购单信息" :label-width="120">
					<el-descriptions-item label="所属门店">
						<span class="descriptions-item-value">{{ subscriptionInfo.storeName }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购人">
						<span class="descriptions-item-value">{{ subscriptionInfo.creator }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购时间">
						<span class="descriptions-item-value">{{ subscriptionInfo.createTime }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="申购单编号">{{ subscriptionInfo.code }}</el-descriptions-item>
					<el-descriptions-item label="申购状态">
						<span class="descriptions-item-value">{{ subscriptionInfo.stateStr }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="快递单号">
						<span class="descriptions-item-value">{{ subscriptionInfo.kdNo }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="备注">{{ subscriptionInfo.remark }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">申购商品信息</div>
					<div class="btnDiv"></div>
				</div>
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="productTableData" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="typeName" label="类型" width="140"></el-table-column>
					<el-table-column prop="productName" label="系列" width="160"></el-table-column>
					<el-table-column prop="specification" label="商品名称" width="160"></el-table-column>
					<el-table-column prop="productBrand" label="商品品牌" width="160"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="70"></el-table-column>
					<el-table-column prop="realQty" label="实际数量" width="90"></el-table-column>
					<el-table-column prop="unit" label="单位" width="70"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="costMoney" label="成本(元)" width="90"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="shippingCost" label="运费(元)" width="90"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="totalMoney" label="小计(元)" width="90">
						<template #default="scope">￥{{ scope.row.costMoney * scope.row.quantity + scope.row.shippingCost }}元</template>
					</el-table-column>
					<el-table-column prop="productDate" label="生产日期" width="110"></el-table-column>
					<el-table-column prop="expireDate" label="过期日期" width="110"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="price" label="售价(元)" width="90"></el-table-column>
					<el-table-column v-if="type == 2" prop="supplyName" label="付款对象" width="120"></el-table-column>
					<el-table-column prop="remark" label="备注" width="250"></el-table-column>
					<el-table-column prop="kdNo" label="快递单号" width="220"></el-table-column>
				</el-table>
			</div>
			<div class="item_info border_Blue">
				<div class="item_title">
					<div class="title">操作记录</div>
					<div class="btnDiv"></div>
				</div>
				<operationLog ref="operationLog"></operationLog>
			</div>
		</div>
		
		<!-- 接收弹窗 -->
		<receiveDialog ref="receiveDialog" @success="onReceiveSuccess"></receiveDialog>
	</lcsj-dialog>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { GetStoreSubscriptionDetail, SubmitStoreSubscription, DeleteStoreSubscription } from "@/api/productApi.js";
import operationLog from "@/views/system/operationLog/businessOperationLog.vue";
import receiveDialog from "./receiveDialog.vue";
export default {
	mixins: [costPermission],
	props: {
		storeList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDetailVisible: false,
			loading: false,
			title: "申购单详情",
			subscriptionInfo: {},
			productTableData: [],
			type: 1
		};
	},
	created() {},
	mounted() {},
	components: {
		operationLog,
		receiveDialog
	},
	methods: {
		// 展示详情
		showDetail(keyId, type) {
			this.subscriptionInfo = {};
			GetStoreSubscriptionDetail({
				keyId: keyId
			}).then((res) => {
				if (res.code == 1) {
					this.subscriptionInfo = res.data;
					this.productTableData = [];
					if (res.data.dtls != null && res.data.dtls.length > 0) {
						var index = 1;
						res.data.dtls.forEach((item) => {
							this.productTableData.push({
								rowNumber: index++,
								productKeyId: item.productTypeInfo.keyId,
								typeName: item.productTypeInfo.typeName,
								productName: item.productTypeInfo.productName,
								specification: item.productTypeInfo.specification,
								quantity: item.quantity,
								unit: item.productTypeInfo.unit,
								remark: item.remark,
								costMoney: item.costMoney,
								productDate: item.productDate,
								expireDate: item.expireDate,
								keyId: item.keyId,
								price: item.price,
								shippingCost: item.shippingCost,
								supplyName: item.supplyName,
								realQty: item.realQty,
								kdNo: item.kdNo,
								productBrand: item.productBrand
							});
						});
					}
					this.title = "申购单详情";
				} else {
					this.$message.error(res.msg);
				}
			});
			this.type = type;
			this.showDetailVisible = true;

			this.$nextTick(() => {
				this.$refs.operationLog.showOperationLog(keyId);
			});
		},
		// 关闭详情弹出框
		closeDialog() {
			this.subscriptionInfo = {};
			this.showDetailVisible = false;
		},
		// 提交
		handleSubmitClick() {
			if (this.subscriptionInfo.state != 1) {
				this.$message({
					type: "warning",
					message: "申购单状态不是待提交状态，不能提交"
				});
				return;
			}
			this.$confirm("确认提交到采购部进行采购吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				SubmitStoreSubscription({
					keyId: this.subscriptionInfo.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "提交成功"
							});
							this.closeDialog();
							this.$parent.getListData();
						} else {
							this.loading = false;
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		},
		// 接收
		handleReceiveClick() {
			if (this.subscriptionInfo.state != 6) {
				this.$message({
					type: "warning",
					message: "申购单状态不是待接收状态，不能接收"
				});
				return;
			}
			this.$refs.receiveDialog.showReceive(this.subscriptionInfo.keyId);
		},
		// 接收成功
		onReceiveSuccess() {
			this.closeDialog();
			this.$parent.getListData();
		},
		// 删除
		handleDeleteClick() {
			if (this.subscriptionInfo.state != 1 && this.subscriptionInfo.state != 2) {
				this.$message({
					type: "warning",
					message: "申购单状态不是待提交状态或待审核状态，不能删除"
				});
				return;
			}
			this.$confirm("确认删除吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				DeleteStoreSubscription({
					keyId: this.subscriptionInfo.keyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.loading = false;
							this.$message({
								type: "success",
								message: "删除成功"
							});
							this.closeDialog();
							this.$parent.getListData();
						} else {
							this.loading = false;
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>

<style scoped>
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.formDiv {
	border: 1px solid var(--app-border);
	padding: 10px;
	border-radius: 5px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border: 2px solid var(--app-border);
}

.border_Blue {
	border-left: 5px solid var(--app-primary-hover);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}
}

.descriptions-item-value {
	display: inline-block;
	min-width: 100px;
	text-align: left;
}
</style>
